import { render, staticRenderFns } from "./segmentsLabel.vue?vue&type=template&id=6c57465a&"
import script from "./segmentsLabel.vue?vue&type=script&lang=js&"
export * from "./segmentsLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports